import { gql } from 'graphql-tag';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useEventYearFilter } from 'components/YearDropdown';
import { usePersistedQuery } from 'hooks/usePersistedQuery';
import { useSearchInput } from 'hooks/useSearchInput';
import { AppContext } from 'shared/AppContext';

export const GET_ACCOUNT_EXPIRED_CREDITS = gql`
  query GetUserExpiredCreditsByAccount($creditsInput: GetUserCreditsInput!) {
    getUserExpiredCreditsByAccount(input: $creditsInput) {
      count
      results {
        id
        user {
          formatted_name
        }
        amount
        date
        issued_by {
          formatted_name
        }
      }
    }
  }
`;

export function useGetUserExpiredCreditsByAccount() {
  const { id: user_id } = useParams();
  const {
    state: { accountId },
  } = useContext(AppContext);

  const { yearFilter } = useEventYearFilter();
  const { input: search } = useSearchInput();

  const result = usePersistedQuery(
    GET_ACCOUNT_EXPIRED_CREDITS,
    `user-expired-credits-by-account-${accountId}-${user_id}`,
    {
      variables: {
        creditsInput: {
          account_id: Number(accountId),
          user_id: Number(user_id),
          ...(yearFilter ? { year: yearFilter } : null),
          ...search,
        },
      },
      fetchPolicy: 'cache-and-network',
    }
  );

  return { ...result, res: result.data };
}
